import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import FleetList from '../Partner/Fleet/FleetList';
import DriverList from '../Partner/Driver/DriverList';
import BorewellList from "../Partner/Borewell/BorewellList";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";


class PartnerLoginAssets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partnerData: ""
      //data: this.props.location.data ?  this.props.location.data : (this.props.location.state.data ? this.props.location.state.data  : '')
    };
    //this.getPartnerId = this.getPartnerId.bind(this);
  }
  nextPath = (path) => {
    console.log(path);
    this.props.history.push({pathname: path, state: {data: this.state} 
    });
    console.log(this.props.history);
  }

  componentDidMount() {
    let userId = this.props.userId;
    let userRole = this.props.userRole; 
    const url = process.env.REACT_APP_NODE_ENV + "/api/partners/getPartnerIdByUser/" + userId
    fetch(url,{
      method:'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => { return response.json();}
    ).then(data => {
      this.setState({partnerData: data[0]})
      console.log(this.state.partnerData)
    })
  }

  render() {
    const { partnerData,data } = this.state
    let showTabs = "";
    if(partnerData.partnerType === "Fleet Operator"){
      showTabs = (
        <Tabs defaultActiveKey="driver">
        <Tab eventKey="driver" title="Driver">
          <DriverList data={partnerData.id} />
        </Tab>
        <Tab eventKey="fleet" title="Fleet">
            <FleetList data={partnerData.id} />
          </Tab>  
      </Tabs>
      )
    }
      else if( partnerData.partnerType === "Independent Tanker"){
        showTabs = (
          <Tabs defaultActiveKey="fleet">
          <Tab eventKey="fleet" title="Fleet">
            <FleetList data={partnerData.id} />
          </Tab>
          <Tab eventKey="driver" title="Driver">
          <DriverList data={partnerData.id} />
        </Tab>
        </Tabs>
        )
      }

     else if(partnerData.partnerType === "Borewell Operator"){
      showTabs = (
        <Tabs defaultActiveKey="borewell">
        <Tab eventKey="borewell" title="Borewell">
          <BorewellList data={partnerData.id} />
        </Tab>
      </Tabs>
      );
    } 
    
    else if(partnerData.partnerType === "Borewell/Fleet Operator"){
      showTabs = (
        <Tabs defaultActiveKey="borewell">
        <Tab eventKey="borewell" title="Borewell">
          <BorewellList data={partnerData.id} />
        </Tab>
        <Tab eventKey="driver" title="Driver">
          <DriverList data={partnerData.id} />
        </Tab>
        <Tab eventKey="fleet" title="Fleet">
          <FleetList data={partnerData.id} />
        </Tab>
      </Tabs>
      );
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Partner Assets</Breadcrumb.Item>
        </Breadcrumb>

        <Card>
          <Card.Body>
            <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
              Partner  Detail -  {this.state.partnerData.partnerFirmName}
            </Card.Title>
            <br />
            <br />
        {showTabs}
          </Card.Body>
        </Card>
      </>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id 
  }
}

export default connect(
  mapStateToProps,
  null
)(withRouter(PartnerLoginAssets))

